class HomeController extends AbstractController
	@register()
	@inject '$scope',
		'$rootScope'
		'translate'
		'ReportService'
		'HighChartsThemeProviderService'
		'ConfigurationService'
		'ShopRepository'
		'MessageTerminal'
		'UserInformation'
		'CurrencyRepository'
		'UserShopRepository'
		'DateService'
		'BACKEND_ORDERS_ANALYTICS_QUERY_TYPE'
		'WEBSHOP_URL'
		'SECONDS'

	initialize: ->
		@defaultCurrency = @UserInformation.getMasterUser().currency
		@filters = {
			start_time: moment().startOf('day').subtract(8, 'days').unix()
			end_time: moment().endOf('day').unix()
			today_start_time: moment().startOf('day').unix()
			today_end_time: moment().endOf('day').unix()
			currency: @defaultCurrency
			shop_id: null
		}

		@MessageTerminal.on(@$scope, @MessageTerminal.events.CSS_LOADED, @resizeChart.bind(@))

		@reports = [
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.QUANTITY,
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TURNOVER,
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.LAST_YEAR_TURNOVER,
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.ORDER_COUNT,
		]

		if @ConfigurationService.isEnabled 'Backoffice.Home.ShowGrossMargin'
			@reports.push(@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.GROSS_MARGIN)

		@createChart()
		@updatePerformanceStats()

		@supportUrl = @ConfigurationService.get 'Backoffice.Setting.SupportUrl', true

		if @ConfigurationService.isEnabled 'Backoffice.Home.Enable.Webshop'
			@masterUserId = @UserInformation.getMasterUser().id
			@ShopRepository
				.list()
				.then (response) =>
					@webshopUrl = @ConfigurationService.get 'Backoffice.Home.WebshopUrl', true

					if !@webshopUrl
						@shopId = response.data[0].id
						@webshopUrl = "#{@WEBSHOP_URL}/mid/#{@masterUserId}/sid/#{@shopId}"

	updatePerformanceStats: () ->
		@loading = true

		@ReportService
			.getOrdersAnalytics(
				@filters.today_start_time,
				@filters.today_end_time,
				@filters.currency,
				true,
				true,
				null,
				@filters.shop_id,
				@reports
			)
			.then (results) =>
				@quantity = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.QUANTITY]
				@lastYearTurnover = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.LAST_YEAR_TURNOVER]
				@turnover = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TURNOVER]
				@ordersCount = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.ORDER_COUNT]
				@grossMargin = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.GROSS_MARGIN] ? null
			.finally =>
				@loading = false

	getTurnoverDifferenceInPercentages: ->
		if @lastYearTurnover == 0
			return null

		differenceInPercents = parseFloat(((@turnover - @lastYearTurnover) / @lastYearTurnover * 100).toFixed(3))

		if differenceInPercents > 0
			differenceInPercents = '+' + differenceInPercents

		return differenceInPercents

	createChart: ->
		Highcharts.setOptions @HighChartsThemeProviderService.get('areaTheme', 'static')

		chartInit = =>
			chartIndex = $('#gross-graph')
				.highcharts({
					global: {
						useUTC: false
					}
					title: {text: @translate('wbo.home.turnover')}
					series: [
						{
							data: [],
						}
					],
				})
				.data('highchartsChart')

			@chart = Highcharts.charts[chartIndex]
			@populateChart()

		watcher = setInterval(
			->
				if $('#gross-graph').width() > 10
					clearInterval watcher
					chartInit()
				return
			,
				100
		)

	resizeChart: ->
		if @chart
			@chart.reflow()

	searchCurrencies: (query) ->
		return @CurrencyRepository
			.findByQuery(query)
			.then (response) -> response.data
			.then (currencies) -> _.map(
				currencies,
				(currency) -> {
					currency...
					currency_name: "#{currency.currency_name} (#{currency.iso})"
				},
			)

	searchShops: (query) ->
		query.with('price_region')

		return @UserShopRepository
			.findByQuery(query)
			.then (response) -> response.data

	onShopChange: (shop) ->
		@filters.currency = shop?.price_region?.currency ? @defaultCurrency
		@populateChart()

	onCurrencyChange: ->
		@populateChart()

	populateChart: ->
		@updatePerformanceStats()

		@$rootScope.ignoreLoader = true
		@graphLoading = true

		@ReportService
			.getOrdersAnalytics(
				@filters.start_time,
				@filters.end_time,
				@filters.currency,
				true,
				true,
				@SECONDS.DAY,
				@filters.shop_id,
				[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.GROUPED_TURNOVER]
			)
			.then (results) =>
				@graphLoading = false
				data = {}
				intervals = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.GROUPED_TURNOVER]

				for index in [0...intervals.length]
					interval = intervals[index]
					timestamp = parseInt(@filters.start_time + parseInt(index * @SECONDS.DAY)) * 1000
					tick = moment(timestamp).format('D. MMM')
					amount = parseFloat(interval.amount / 100)
					data[tick] ?= 0
					data[tick] += amount

				@chart.axes[0].update({categories: Object.keys(data)})
				@chart.series[0].setData(Object.values(data))
			.finally =>
				@$rootScope.ignoreLoader = false
